import React from "react";

function ApplicableCustomerTable({ customers }: any) {
  return (
    <div className="relative overflow-x-auto">
      <table className="min-w-[400px] w-full table-auto text-sm ml:text-base">
        <thead>
          <tr className="border-b border-[#EEEFF2]">
            <th className="py-4 px-4 font-normal text-left text-base-300">Customer Id</th>
            <th className="py-4 px-4 font-normal text-left text-base-300">Customer Name</th>
          </tr>
        </thead>
        <tbody>
          {customers.map((customer: any, index: number) => (
            <tr className="border-b border-[#EEEFF2] font-semibold" key={index}>
              <td className="text-left py-3 px-4">{customer.customer.id}</td>
              <td className="text-left py-3 px-4">{customer.customer.name}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ApplicableCustomerTable;
